import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import UriUtils from '../modules/UriUtils';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const PrepaidAccountService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  const getAutoreloadByPrepaidAccountId = (prepaidAccountId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(prepaidAccountId);
    return axios.get(`${BASE_URL}/autoreload/search${queryString}`, {
      headers,
    });
  };

  const getPrepaidAccountsBySearchCriteria = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/prepaid-accounts/accounts/search${queryString}`, {
      headers,
    });
  };

  const getPrepaidTransactionsByAccountId = (accountId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(accountId);
    return axios.get(`${BASE_URL}/prepaid-accounts/transactions/search${queryString}`, {
      headers,
    });
  };

  const linkPrepaidAccountToCustomer = (prepaidAccountId, customerId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(`${BASE_URL}/prepaid-accounts/${prepaidAccountId}/link/${customerId}`, undefined, {
      headers,
    });
  };

  const unlinkPrepaidAccountFromCustomer = (prepaidAccountId, customerId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.delete(`${BASE_URL}/prepaid-accounts/${prepaidAccountId}/unlink/${customerId}`, {
      headers,
    });
  };

  const removeAutoReloadFromPrepaidAccount = (autoReloadId) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.delete(`${BASE_URL}/autoreloadaccounts/${autoReloadId}`, {
      headers,
    });
  };

  service.getAutoreloadByPrepaidAccountId = getAutoreloadByPrepaidAccountId;
  service.getPrepaidAccountsBySearchCriteria = getPrepaidAccountsBySearchCriteria;
  service.getPrepaidTransactionsByAccountId = getPrepaidTransactionsByAccountId;
  service.linkPrepaidAccountToCustomer = linkPrepaidAccountToCustomer;
  service.unlinkPrepaidAccountFromCustomer = unlinkPrepaidAccountFromCustomer;
  service.removeAutoReloadFromPrepaidAccount = removeAutoReloadFromPrepaidAccount;

  return service;
})();

export default PrepaidAccountService;
